import React from "react";
import Select from "react-select";

const CreditBalancesSearchForm = ({
  school,
  student,
  setSchool,
  setStudent,
  searchCreditBalances,
  resetSearch,
  setPage,
  schoolList
}) => {
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchCreditBalances(e);
  };

  
const handleStudentChange = (e) => {
    const value = e.target.value;
    setStudent(value);
    setPage(1);
    if (value === '') {
      resetSearch(e);
    }
};

  return (
    <form className="mg-t-20" onSubmit={handleSearchSubmit}>
      <div className="row gutters-5">
        <div className="col-10-xxxl col-lg-10 col-12 form-group">
          <div className="row">
          <div className="col-lg-6 mt-2">
              <input
                type="text"
                placeholder="Enter first or last name..."
                style={{ border: "1px solid grey" }}
                value={student}
                onChange={handleStudentChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-6 mt-2">
              <Select
                onChange={(e) => setSchool(e ? e.school_id : "")}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                  school === ""
                    ? null
                    : Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_id === school)
                }
              />
            </div>
          </div>
        </div>

        <div className="col-2-xxxl col-lg-2 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreditBalancesSearchForm;